import { useMemo } from '@wordpress/element';
import { motion, AnimatePresence } from 'framer-motion';
import { useCompare } from '../../../store/compare';

export const CompareBar = ({ onOpen, className = '' }) => {
    const { items, remove, clear } = useCompare();
    const count = items?.length || 0;
    const thumbs = useMemo(() => items ? items.slice(0, 4) : [], [items]);

    return (
        <AnimatePresence initial={false}>
            {count > 0 && (
                <motion.div
                    className={`fixed inset-x-0 bottom-0 z-[1001] bg-dark-blue text-white shadow-2xl ${className}`}
                    initial={{ y: '100%' }}
                    animate={{ y: 0 }}
                    exit={{ y: '100%' }}
                    transition={{ type: 'spring', stiffness: 300, damping: 30 }}
                >
                    <div className="container mx-auto px-4 py-6">
                        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
                            <div className="flex flex-col gap-1">
                                <h3 className="text-2xl font-black !text-white">Compare Products</h3>
                            </div>

                            <div className="flex items-center gap-4">
                                <button
                                    className="btn bg-[#FE7C22] hover:bg-[#FE7C22]/90 border-none text-white font-bold px-8 pt-btn-pill"
                                    onClick={onOpen}
                                >
                                    Compare Products
                                </button>
                                <button
                                    className="btn btn-outline border-white/30 text-white hover:bg-white/10 px-8 pt-btn-pill"
                                    onClick={clear}
                                >
                                    Clear All
                                </button>
                            </div>
                        </div>

                        <div className="flex flex-wrap gap-4 mt-6">
                            {thumbs.map(p => (
                                <motion.div
                                    key={p.sku}
                                    className="bg-white rounded-xl p-3 flex items-center gap-4 relative group w-full sm:w-[calc(50%-1rem)] lg:w-[calc(25%-1rem)]"
                                    initial={{ opacity: 0, scale: 0.9 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                    exit={{ opacity: 0, scale: 0.9 }}
                                    transition={{ type: 'spring', stiffness: 400, damping: 25 }}
                                    layout
                                >
                                    <div className="w-16 h-16 shrink-0 bg-white rounded-lg p-1">
                                        <img
                                            src={p.image}
                                            alt={p.name}
                                            className="w-full h-full object-contain"
                                        />
                                    </div>
                                    <div className="flex-1 min-w-0">
                                        <div className="text-[10px] text-[#FE7C22] font-black uppercase mb-0.5">
                                            {p.manufacturer}
                                        </div>
                                        <div className="text-[11px] text-[#044165]/60 font-bold line-clamp-2 leading-tight">
                                            {p.name}
                                        </div>
                                    </div>
                                    <button
                                        className="absolute -top-2 -right-2 w-6 h-6 bg-white shadow-md rounded-full flex items-center justify-center text-[#044165] hover:text-red-500 transition-colors"
                                        onClick={() => remove(p.sku)}
                                    >
                                        <span className="text-lg leading-none">&times;</span>
                                    </button>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};